import { render, staticRenderFns } from "./CmTextImageHighlight.vue?vue&type=template&id=69fb3e03"
import script from "./CmTextImageHighlight.vue?vue&type=script&lang=ts"
export * from "./CmTextImageHighlight.vue?vue&type=script&lang=ts"
import style0 from "./CmTextImageHighlight.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default})
